module.exports = __webpack_public_path__ + "img/sketch.fa56686d.png";